import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { PAYMENT_TYPES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { requests } from 'src/requests';
import { HintBox } from 'src/view/components/Controls/HintBox/HintBox';
import { OrderStore } from '~/mobx/orderStore';
import logger from '~/services/logger';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import Text from '~/view/components/Text/Text';
import { withOrderStore } from '~/view/screens/OrderScreen/context';

interface IState {
  messageResponse: string | null;
  disable: boolean;
  isSuccess: boolean;
  loading: boolean;
  hintBox: boolean;
}

// @ts-ignore
@withOrderStore
@observer
export default class ResendSMS extends React.Component<{ orderStore?: OrderStore }, IState> {
  state = {
    messageResponse: null,
    disable: false,
    isSuccess: true,
    loading: false,
    hintBox: true,
  };
  private timer: NodeJS.Timeout | null = null;

  get orderStore() {
    return this.props.orderStore!;
  }

  componentDidMount = () => {
    this.availableResendSMS();
  };

  componentWillUnmount = () => {
    if (this.timer) clearTimeout(this.timer);
  };

  private availableResendSMS = () => {
    /**
     * Show btn
     */
    if (moment((this.orderStore?.order?.sms?.resend_available_at || 0) * 1000).isBefore(moment())) {
      return this.setState({ disable: false });
    }
    return this.setState({ disable: true });
  };

  showMessageRequest = (status: boolean) => {
    this.setState({
      messageResponse: localeStore.t(status ? 'sms_sent' : 'sms_not_sent'),
      isSuccess: status,
    });

    this.timer = setTimeout(() => {
      this.setState({ messageResponse: null });
    }, 3000);
  };
  private resendSMS = async () => {
    if (this.state.disable) return null;

    const type = this.orderStore.order?.sms?.type as number;
    const orderID = this.orderStore.order?.id;

    try {
      this.setState({ loading: true });

      const { available_at, result } = await requests.resendSMS(orderID, type);

      this.orderStore.updateResendSMSBtn(available_at);
      this.showMessageRequest(result);
      this.availableResendSMS();

      this.timer = setTimeout(() => {
        this.availableResendSMS();
      }, 180000);

      this.setState({ loading: false });
    } catch (error: any) {
      this.showMessageRequest(false);
      this.availableResendSMS();
      this.setState({ loading: false });
      logger.error({ error, place: 'ResendSMS resendSMS' });
    }
  };

  closeHint = () => {
    this.setState({ hintBox: !this.state.hintBox });
  };

  get textForHint(): string {
    switch (true) {
      case this.orderStore.order?.payment_type !== PAYMENT_TYPES.ONLINE_PAYMENT:
        return 'to_specify_geolocation';
      case this.orderStore.order?.sms?.type === 1:
        return 'to_pay_online';
      default:
        return 'geolocation_and_pay';
    }
  }

  public render() {
    return (
      <div className="d-flex flex-column flex-1 mb-4">
        <HintBox open={this.state.hintBox} text={this.textForHint} onClick={this.closeHint}>
          <Button
            title={localeStore.t('resend_sms')}
            onClick={this.resendSMS}
            disabled={this.state.disable}
            loading={this.state.loading}
            appearance="tertiary"
            size="large"
            stretched
          />

          {this.state.messageResponse ? (
            <Text type="error" text={this.state.messageResponse} noTranslate className={this.state.isSuccess ? 'color-green' : undefined} />
          ) : null}
        </HintBox>
      </div>
    );
  }
}
